import { Component, OnInit } from '@angular/core';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { LocalServiceService } from '../../shareModule/services/local-service.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-subadmin-orders',
  templateUrl: './subadmin-orders.component.html',
  styleUrls: ['./subadmin-orders.component.scss']
})
export class SubadminOrdersComponent implements OnInit {
  private modalRef: any;
  orders: any;
  order_detail: any;
  imgUrl = environment.ImageUrl;

  constructor(
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private router: Router,
    private local: LocalServiceService,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.order_listing();
  }

  order_listing() {
    this.auth.subadmin_order_listing().subscribe((response: any) => {
     this.orders = response.body;
    }, (e) => {
      if (e.status == 400) {
        this.toastr.error(e.error.message);
      }
      if (e.error.status == 401 || e.status == 401) {
        this.local.logout();
        this.router.navigate(['/admin']);
      }
    });
  }

  change_order_status(orderId, status) {
    console.log(orderId)
    console.log(status)

    const formData = new FormData();
    formData.append("orderId", orderId);
    formData.append("status", status);
    this.auth.change_order_status(formData).subscribe((response: any) => {
      if(response.body.status == 1) {
        this.toastr.success(response.message);
      } else if (response.body.status == 2) {
        this.toastr.warning(response.message);
      } else if (response.body.status == 3) {
        this.toastr.warning(response.message);
      } else {
        this.toastr.info(response.message);
      }
     }, (e) => {
       if (e.status == 400) {
         this.toastr.error(e.error.message);
       }
       if (e.error.status == 401 || e.status == 401) {
         this.local.logout();
         this.router.navigate(['/admin']);
       }
     });
  }

  order_details(modal, orderId) {
    this.order_detail = this.orders.find(data => data.id == orderId);
    this.modalService.dismissAll();
    this.modalRef = this.modalService.open(modal, { size: 'sm', ariaLabelledBy: 'modal-basic-title', windowClass: 'modal_dialog_pad' });
  }

}
